import { faHeart } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as solidHeart } from "@jewlr/pro-solid-svg-icons/faHeart"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import NavIcon from "areas/header/nav-icon"
import { cn } from "styles/utils"

const WishlistIcon = ({ count, wishlistLoading }) => {
  return (
    <Link
      aria-label="Our Collection"
      className="inline-flex"
      data-lc="wishlist-icon"
      to="/collection"
    >
      <NavIcon
        className={cn(
          count > 0 ? "text-wishlist" : "text-black-print",
          wishlistLoading && "text-black-print animate-spin"
        )}
        icon={wishlistLoading ? faSpinner : count > 0 ? solidHeart : faHeart}
      />
    </Link>
  )
}

WishlistIcon.propTypes = {
  count: PropTypes.number,
  wishlistLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    count: state.wishlist.count,
    wishlistLoading: state.wishlist.loading,
  }
}

export default connect(mapStateToProps)(WishlistIcon)
